import Vue from 'vue';
import VueRouter from 'vue-router'
import App from './App.vue';
import "bootstrap";
import {library} from "@fortawesome/fontawesome-svg-core";
import "bootstrap/dist/css/bootstrap.css";
import "animate.css/animate.css";
import vuetify from '@/plugins/vuetify';
import VueI18n from 'vue-i18n';
import messages from './lang';
import Vue2Editor from 'vue2-editor';
import Toasted from 'vue-toasted';
//import AudioRecorder from 'vue-audio-recorder';

// tmp deactive
//import VueRecord from '@codekraft-studio/vue-record';
import VueWaveSurfer from 'vue-wave-surfer';
import VModal from 'vue-js-modal';
import VueFilterDateFormat from '@vuejs-community/vue-filter-date-format';
import VueFilterDateParse from '@vuejs-community/vue-filter-date-parse';
import VueLazyload from 'vue-lazyload';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueCookies from 'vue-cookies';

import store from './helper/store.js';

import {
  faBrain,
  faBoxes
} from "@fortawesome/free-solid-svg-icons";

import './assets/css/tagsinput.css';
import './assets/css/style.css';

import Stage from "./components/Stage.vue";
import NLP from "./components/NLP.vue";
//import NLPtest from "./components/NLPtest.vue";
import Chatbot from "./components/Chatbot.vue";
import NAO from "./components/NAO.vue";
import UsecaseFrame from "./components/UsecaseFrame.vue";

import Profile from "./components/Profile.vue";
import AdminContent from "./components/AdminContent.vue";
import Content from "./components/Content.vue";
import Contents from "./components/Contents.vue";
import Login from "./components/Login.vue";

import Node from "./components/Node.vue";
import NodeAdd from "./components/NodeAdd.vue";

//import Space from "./components/Space.vue";
//import SpaceBib from "./components/SpaceBib.vue";

import Panorama from "./components/Panorama.vue";
import PanoramaFrame from "./components/PanoramaFrame.vue";
import Suche from "./components/Suche.vue";
import Thema from "./components/Thema.vue";
import Home from "./components/Home.vue";
import Virtuell from "./components/Virtuell.vue";


library.add(faBrain, faBoxes);

// GLOBALs
function host(url) {
  var host;
  var key;
  switch (url) {
    case 'localhost':
      host = 'local';
      key = 'thwi';
      break;
    case 'testbed.innohub13.de':
      host = 'testbed';
      key = 'btu_c';
      break;
    case 'testbeddev.innohub13.de':
      host = 'testbed';
      key = 'btu_c';
      break;
    case 'icampus.th-wildau.de':
      host = 'icampus';
      key = 'thwi';
      break;
  }  
  return {host: host, key: key}
}

console.log('ENVs:');
console.log(process.env);

Vue.prototype.$host = host(location.hostname).host;
Vue.prototype.$key = host(location.hostname).key;
//Vue.prototype.$host = 'icampus';
//Vue.prototype.$template = process.env.VUE_APP_TEMPLATE || 'default';
/**
 * 'default': testbed 
 * 'innoxr': vr.innohub
 * 'icampus': icampus web
 */
Vue.prototype.$template = 'icampus';
Vue.prototype.$panoData = [];
var $home = Vue.prototype.$template === 'icampus' ? "vr/" : "";
Vue.prototype.$home = $home;
// var naoserver = process.env.VUE_APP_NAOSERVER || '/naoserver/';
// console.log(naoserver);
Vue.prototype.$config = {
 //   host: process.env.VUE_APP_BACKEND_HOST || "https://testbeddev-backend.innohub13.de",
    host: process.env.VUE_APP_BACKEND_HOST || 'https://icampus.th-wildau.de/vr_backend',
    imagepath: 'https://icampus.th-wildau.de/vr/files/images/',
    // imagepath: location.origin + '/files/images/',
    graphpath: 'https://icampus.th-wildau.de/vr/graf/',
    tb_host: process.env.VUE_APP_DSP_API_HOST || location.origin + '/dsp-api/',
    VUE_APP_ORS_KEY: process.env.VUE_APP_ORS_KEY || ''
};

/**
 * Socket connection
 */
/* 
import socketio from 'socket.io-client';
import VueSocketIO from 'vue-socket.io';

//const SocketInstance = socketio.connect('https://testbeddev.innohub13.de', {   
const SocketInstance = socketio.connect(naoserver, {
    //path: naoserver + "socket.io",
    path: "/socket.io",
    secure: true,
    //secure: false,
    query: {
        token: window.localStorage.getItem('auth')
    }
});

Vue.use(new VueSocketIO({
    debug: true,
    connection: SocketInstance
}));
 */

// Get the browser's default language
const browserLanguage = navigator.language || navigator.languages[0];
// console.log('Browser language?');
// console.log(browserLanguage);
const locale = browserLanguage ? browserLanguage : 'de';

Vue.use(VueI18n);
export const i18n = new VueI18n({
  locale: locale,
  fallbackLocale: 'de',
  messages
});

//Vue.use(abilitiesPlugin, ability);

Vue.use(VueRouter);
Vue.use(Vue2Editor);
Vue.use(VModal);
Vue.use(VueAxios, axios);
Vue.use(VueLazyload);
var toastoptions = {
    position: 'top-center',
    duration: 4000
}
Vue.use(Toasted, toastoptions);
//Vue.use(AudioRecorder);

// tmp deactive
//Vue.use(VueRecord);
Vue.use(VueWaveSurfer);

Vue.use(VueCookies);
Vue.use(VueFilterDateFormat);
Vue.use(VueFilterDateParse);


axios.defaults.withCredentials = true;

//Generate random token:
const token = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

// set global cookie
Vue.$cookies.config('7d','','',true, 'None');
//Vue.$cookies.set('USERID',token, null, null, 'rosassdev.innohub13.de', true);
Vue.$cookies.set('USERID',token);
//Vue.$cookies.set('USERID',token,'7d','.innohub13.de' );


store.commit('clearUser');


Vue.config.productionTip = false;

const router = new VueRouter({
  mode: 'history',
  routes: [    
    {
      path: "/"+$home,
      component: Home,
      name: "Home"
    },    
    {
      path: "/"+$home+"virtuell",
      component: Virtuell,
      name: "Virtuell"
    },
    {
      path: "/"+$home+"t/nao-roboter",
      component: Stage,
      name: "Stage"
    },    
    {
      path: "/"+$home+"t/id/:url",
      component: UsecaseFrame,
      name: "UsecaseFrame",      
      props: (route) => ({         
        query: route.params.url
      })
    },        
    {
      path: "/"+$home+"t/chatbot",
      component: Chatbot,
      name: "Chatbot"
    },
    {
      path: "/"+$home+"nao",
      component: NAO,
      name: "NAO"
    },
    /*
    {
      path: "/"+$home+"nlp-test",
      component: NLPtest,
      name: "NLP-test"
    },*/    
    {
      path: "/"+$home+"list",
      component: Profile,
      name: "List"
    },
    {
      path: "/"+$home+"admin",
      component: AdminContent,
      name: "Admin"
    },
    {
      path: "/"+$home+"content/:nodetype",
      component: AdminContent,
      name: "AdminContent"
    },
    {
      path: "/"+$home+"p/devices/:nodeid",
      component: Contents,
      name: "Contents",
      props: (route) => ({ nodeid: parseInt(route.query.nodeid) })
    },        
    {
      path: "/"+$home+"p/:nodetype/:nodeid",
      component: Content,
      name: "Content"
    },
    {
      path: "/"+$home+"node/add/:nodetype",
      component: NodeAdd,
      name: "NodeAdd"
    },
    {
      path: "/"+$home+"node/:nodetype/:nodeid",
      component: Node,
      name: "Node"
    },
    {
      path: "/"+$home+"panorama",
      component: PanoramaFrame,
      name: "PanoramaFrame",
      props: (route) => ({ 
        query: parseInt(route.query.q),
        map: parseInt(route.query.m),
        room: route.query.r 
      })
    },
    {
      path: "/"+$home+"pn/:panoid/:tourid",
      component: PanoramaFrame,
      name: "Panotour",
      props: (route) => ({         
        query: parseInt(route.params.panoid),        
        tour: parseInt(route.params.tourid)
      })
    },
    {
      path: "/"+$home+"pn/:panoid/p/:poiid",
      component: PanoramaFrame,
      name: "Panopoi",
      props: (route) => ({         
        query: parseInt(route.params.panoid),
        poiid: parseInt(route.params.poiid)
      })
    },        
    {
      path: "/"+$home+"pn/:panoid",
      component: PanoramaFrame,
      name: "Panosingle",
      props: (route) => ({         
        query: parseInt(route.params.panoid)        
      })
    },        
    {
      path: "/"+$home+"wiwo2023",
      redirect: { 
        name: 'PanoramaFrame', 
        query: { q: 645 }
      }      
    },        
    {
      path: "/"+$home+"ukrainische-akademie",
      redirect: { 
        name: 'PanoramaFrame', 
        query: { q: 191 }
      }      
    },            
    {
      path: "/"+$home+"wiwo2022",
      redirect: { 
        name: 'PanoramaFrame', 
        query: { q: 427 }
      }      
    },    
    {
      path: "/"+$home+"wiwo2024",
      redirect: { 
        name: 'PanoramaFrame', 
        query: { q: 680 }
      }      
    }, 
    {
      path: "/"+$home+"wiwo2025",
      redirect: { 
        name: 'PanoramaFrame', 
        query: { q: 689 }
      }      
    },            
    {
      path: "/"+$home+"wiwo25",
      redirect: { 
        name: 'PanoramaFrame', 
        query: { q: 689 }
      }      
    },                
    {
      path: "/"+$home+"wiwo2021",
      redirect: { 
        name: 'PanoramaFrame', 
        query: { q: 260 }
      }      
    },
    {
      path: "/"+$home+"wiwo21",
      redirect: { 
        name: 'PanoramaFrame', 
        query: { q: 260 }
      }      
    },    
    {
      path: "/"+$home+"wiwo2021/ebs",
      redirect: { 
        name: 'PanoramaFrame', 
        query: { q: 258 }
      }      
    },    
    {
      path: "/"+$home+"wiwo21/ebs",
      redirect: { 
        name: 'PanoramaFrame', 
        query: { q: 258 }
      }      
    },        
    {
      path: "/"+$home+"panosingle",
      component: Panorama,
      name: "Single"
    },
/*    {
      path: "/"+$home+"suche",
      component: Suche,
      name: "Suche"
    },    
*/    
    {
      path: "/"+$home+"suche",
      component: Suche,
      name: "Suche",
      props: (route) => ({         
        query: route.query.t
      })
    },
    /**
     * Suche nach Thema
     */
    {
      path: "/"+$home+"thema/:tagid",
      component: Thema,
      name: "Thema",
      props: (route) => ({         
        query: route.params.tagid
      })
    },
    {
      path: "/"+$home+"login",
      component: Login,
      name: "Login"
    },
    {
      //path: "/"+$home+"nlp",
      path: "/"+$home+"t/nlp-process",
      component: NLP,
      name: "NLP"
    }
  ],
  scrollBehavior() {
        return {x: 0, y: 0}
    }
})

export const eventBus = new Vue();

new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
